module.exports = __webpack_public_path__ + "img/Woocommerce.2fedae87.png";